// ============================================================
// CART DRAWER PRICE HANDLER - BREZZA SUPER MIX
// Fixed: Waits for cart items to load before updating
// ============================================================

(function() {
    'use strict';

    const CONFIG = {
        productId: '9935999303995',
        variantId: '50170607993147',
        originalPrice: 19999, // cents
        cartDrawerSelector: '#CartDrawer',
        cartItemsSelector: 'cart-drawer-items, .cart-items, [id*="cart-drawer-items"]'
    };

    function log(message, data = null) {
        if (data) {
            console.log(`🎨 ${message}`, data);
        } else {
            console.log(`🎨 ${message}`);
        }
    }

    // ============================================================
    // WAIT FOR CART ITEMS TO LOAD
    // ============================================================
    function waitForCartItems(callback, timeout = 5000) {
        const startTime = Date.now();
        const checkInterval = 100;

        function check() {
            // Look for ANY element with cart item price
            const priceElements = document.querySelectorAll(
                '#CartDrawer .cart-item__price, ' +
                '#CartDrawer [class*="price"], ' +
                'cart-drawer-items .price, ' +
                '.drawer__inner .price'
            );

            if (priceElements.length > 0) {
                log(`✅ Found ${priceElements.length} price elements in cart`);
                callback();
                return;
            }

            if (Date.now() - startTime < timeout) {
                setTimeout(check, checkInterval);
            } else {
                log('⏱️ Timeout waiting for cart items');
            }
        }

        check();
    }

    // ============================================================
    // UPDATE CART DRAWER PRICES
    // ============================================================
    function updateCartDrawerPrices() {
        const testData = sessionStorage.getItem('price_test_current');
        
        if (!testData) {
            log('No test data found in session');
            return;
        }

        let data;
        try {
            data = JSON.parse(testData);
        } catch (e) {
            log('Failed to parse test data');
            return;
        }

        const testPrice = data.testPrice; // in cents
        
        if (!testPrice || testPrice === CONFIG.originalPrice) {
            log('No price update needed');
            return;
        }

        // Find ALL price displays in cart drawer
        const priceSelectors = [
            '#CartDrawer .cart-item__price-wrapper .price',
            '#CartDrawer [class*="cart-item"] [class*="price"]',
            'cart-drawer-items .price',
            '.drawer__inner .price',
            '#CartDrawer .price__regular'
        ];

        let updated = 0;
        
        priceSelectors.forEach(selector => {
            const elements = document.querySelectorAll(selector);
            elements.forEach(el => {
                const currentText = el.textContent.trim();
                
                // Only update if it's showing the old price
                if (currentText.includes('$199.99') || currentText.includes('$189.99') || currentText.includes('$179.99') || currentText.includes('$299.99')) {
                    const newPrice = `$${(testPrice / 100).toFixed(2)}`;
                    el.textContent = newPrice;
                    log(`✅ Updated cart price: "${currentText}" → "${newPrice}"`);
                    updated++;
                }
            });
        });

        if (updated === 0) {
            log('⚠️ No prices updated - checking what elements exist...');
            const allPrices = document.querySelectorAll('#CartDrawer [class*="price"]');
            log(`Found ${allPrices.length} price elements in drawer`);
        } else {
            log(`✅ Updated ${updated} cart drawer price(s)`);
            // Always try to update subtotal after updating prices
            updateSubtotal(testPrice);
        }
    }

    // ============================================================
    // UPDATE SUBTOTAL
    // ============================================================
    function updateSubtotal(testPriceCents) {
        // Find subtotal element - use the specific class we identified
        const subtotalElement = document.querySelector('.totals__subtotal-value.font-body-bolder');

        if (!subtotalElement) {
            log('⚠️ Subtotal element not found');
            return;
        }

        log('🔍 Found subtotal element, fetching cart data...');

        // Get current cart data to calculate correct total
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                // Calculate: (other items total) + (brezza items at test price)
                let otherItemsTotal = 0;
                let brezzaQuantity = 0;
                
                cart.items.forEach(item => {
                    // Check if this is a Brezza Super Mix item
                    if (item.variant_id == CONFIG.variantId || item.product_id == CONFIG.productId) {
                        brezzaQuantity += item.quantity;
                    } else {
                        otherItemsTotal += item.line_price;
                    }
                });

                log(`📦 Cart data: Brezza qty=${brezzaQuantity}, Other items total=$${(otherItemsTotal/100).toFixed(2)}`);

                // Calculate new subtotal
                const brezzaTestTotal = testPriceCents * brezzaQuantity;
                const newSubtotalCents = otherItemsTotal + brezzaTestTotal;
                const newSubtotalDollars = (newSubtotalCents / 100).toFixed(2);

                // Update the display
                const currentText = subtotalElement.textContent;
                subtotalElement.textContent = `$${newSubtotalDollars}`;
                
                log(`✅ Updated subtotal: "${currentText.trim()}" → "$${newSubtotalDollars}"`);
                log(`📊 Breakdown: Other items: $${(otherItemsTotal/100).toFixed(2)} + Brezza (${brezzaQuantity}x): $${(brezzaTestTotal/100).toFixed(2)}`);
            })
            .catch(err => {
                log('⚠️ Failed to fetch cart data for subtotal update', err);
            });
    }

    // ============================================================
    // INTERCEPT CART DRAWER SHOW
    // ============================================================
    function interceptCartDrawer() {
        const drawer = document.querySelector(CONFIG.cartDrawerSelector);
        
        if (!drawer) {
            log('⚠️ Cart drawer not found');
            return;
        }

        log('👀 Watching cart drawer:', CONFIG.cartDrawerSelector);

        // Watch for drawer opening
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'open' && drawer.hasAttribute('open')) {
                    log('🚪 Cart drawer opened - waiting for items to load...');
                    
                    // Wait for items to actually load, THEN update prices
                    waitForCartItems(() => {
                        updateCartDrawerPrices();
                    });
                }
            });
        });

        observer.observe(drawer, {
            attributes: true,
            attributeFilter: ['open']
        });

        log('✅ Cart drawer observer active');
    }

    // ============================================================
    // REAPPLY DISCOUNT CODE TO CART
    // ============================================================
    function reapplyDiscountCode() {
        const discountCode = sessionStorage.getItem('price_test_discount_code');
        const testProduct = sessionStorage.getItem('price_test_variant');
        
        if (!discountCode || !testProduct) {
            return;
        }

        // Check if Brezza is still in cart
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                const hasBrezza = cart.items.some(item => 
                    item.variant_id == CONFIG.variantId || item.product_id == CONFIG.productId
                );
                
                if (hasBrezza) {
                    log(`🔁 Reapplying discount code: ${discountCode}`);
                    
                    // Update cart with discount code
                    fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            attributes: {
                                discount_code: discountCode
                            }
                        })
                    })
                    .then(res => res.json())
                    .then(() => {
                        log(`✅ Discount code reapplied: ${discountCode}`);
                    })
                    .catch(err => {
                        log('⚠️ Failed to reapply discount code', err);
                    });
                } else {
                    log('No Brezza in cart, clearing discount data');
                    sessionStorage.removeItem('price_test_discount_code');
                    sessionStorage.removeItem('price_test_variant');
                    sessionStorage.removeItem('price_test_current');
                }
            })
            .catch(err => {
                log('⚠️ Failed to check cart for discount reapplication', err);
            });
    }

    // ============================================================
    // LISTEN FOR CART EVENTS
    // ============================================================
    function listenForCartEvents() {
        // Shopify cart update events
        document.addEventListener('cart:updated', () => {
            log('📢 Cart event: cart:updated');
            waitForCartItems(() => {
                updateCartDrawerPrices();
                reapplyDiscountCode();
            });
        });

        document.addEventListener('cart:changed', () => {
            log('📢 Cart event: cart:changed');
            waitForCartItems(() => {
                updateCartDrawerPrices();
                reapplyDiscountCode();
            });
        });
    }

    // ============================================================
    // INTERCEPT CHECKOUT BUTTON
    // ============================================================
    function interceptCheckoutButton() {
        const discountCode = sessionStorage.getItem('price_test_discount_code');
        
        if (!discountCode) {
            return;
        }

        log('🎯 Setting up checkout button interception');

        // Intercept all checkout buttons
        document.addEventListener('click', function(e) {
            const checkoutButton = e.target.closest('button[name="checkout"], button[type="submit"][class*="checkout"], a[href*="/checkout"]');
            
            if (!checkoutButton) return;

            // Check if we're in the cart drawer
            const inCartDrawer = checkoutButton.closest('#CartDrawer');
            if (!inCartDrawer) return;

            e.preventDefault();
            e.stopPropagation();

            log(`🛑 Intercepted checkout button, applying discount: ${discountCode}`);

            // Redirect to checkout with discount code
            const checkoutUrl = `/checkout?discount=${discountCode}`;
            log(`🚀 Redirecting to: ${checkoutUrl}`);
            window.location.href = checkoutUrl;

            return false;
        }, true);

        log('✅ Checkout button interception active');
    }

    // ============================================================
    // WATCH FOR CART DOM CHANGES AND RE-APPLY PRICES
    // ============================================================
    function watchCartForChanges() {
        const cartDrawer = document.querySelector(CONFIG.cartDrawerSelector);
        if (!cartDrawer) {
            log('⚠️ Cart drawer not found for mutation observer');
            return;
        }

        // Create observer to watch for cart re-renders
        const observer = new MutationObserver((mutations) => {
            // Check if Brezza prices exist in the cart
            const testPrice = sessionStorage.getItem('price_test_price');
            if (!testPrice) return;

            // Debounce: only run once per batch of mutations
            clearTimeout(window.priceUpdateTimeout);
            window.priceUpdateTimeout = setTimeout(() => {
                log('🔄 Cart DOM changed, re-applying prices...');
                updateCartDrawerPrices();
            }, 100);
        });

        // Watch cart drawer for any changes
        observer.observe(cartDrawer, {
            childList: true,
            subtree: true
        });

        log('👁️ Started watching cart for DOM changes');
    }

    // ============================================================
    // INITIALIZE
    // ============================================================
    function init() {
        log('Cart Drawer Price Handler Initialized (Brezza)');
        
        interceptCartDrawer();
        listenForCartEvents();
        interceptCheckoutButton();
        watchCartForChanges();
        
        // Also try immediate update if drawer is already open
        const drawer = document.querySelector(CONFIG.cartDrawerSelector);
        if (drawer && drawer.hasAttribute('open')) {
            log('Cart drawer already open - waiting for items...');
            waitForCartItems(() => {
                updateCartDrawerPrices();
            });
        }
    }

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
